namespace Solovis.Reports.Parameters {

    interface Entity {
        label: string;
        entityId: number;
        resourceId: number;
    }

    export class EntityParameterControl extends Solovis.UI.BaseControl {

        public initialParameterValue;
        public currentEntity;

        public selectedEntityLabel;
        public selectEntityLink;

        private _selectionDialog: Solovis.UI.Dialog;

        private _portalServices: Solovis.Portal.IPortalServices;

        // NOTE: related to new render
        private _entities: Array<Entity>;
        static hasNewRender = true;
        private _selectRef;

        constructor(options) {
            super(options);

            this._portalServices = options.portalServices;

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            this.currentEntity = this.initialParameterValue;
        }


        public static preload(newValue, callback, portalServices: Solovis.Portal.IPortalServices) {
            if (!portalServices) {
                portalServices = new Solovis.Portal.SitePortalServices();
            }

            if (newValue && (newValue.entityId || newValue.resourceId || newValue.entityCode)) {
                var loadOptions: any = { entity: {} };
                if (newValue.entityId)
                    loadOptions.entity.id = newValue.entityId;
                if (newValue.resourceId)
                    loadOptions.entity.resourceId = newValue.resourceId;
                if (newValue.entityCode)
                    loadOptions.entity.code = newValue.entityCode;

                portalServices.reportDataLoader().loadDataSetAsync("/Solovis/Metadata/ParameterLoad",
                    loadOptions,
                    function (response, success) {
                        if (success) {
                            var dataSet = response.result.dataSet;
                            var entityData = dataSet.entity ? dataSet.entity : null;
                            callback(entityData, true);
                        }
                        else {
                            callback(null, false);
                        }
                    });
            }
            else {
                callback(null, true);
            }
        };

        public static shouldPreload(value) {
            if (!value || (value.entityId && value.resourceId && value.label)) {
                // Already loaded.
                return false;
            }

            return true;
        }

        public static serializeParameterValue(value): any {
            if (value) {
                if (value.entityId) {
                    return { entityId: value.entityId };
                }
                else if (value.resourceId) {
                    return { resourceId: value.resourceId };
                }
                else if (value.entityCode) {
                    return { entityCode: value.entityCode };
                }
            }

            return null;
        }

        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }

        private async doRenderNew() {
            var self = this;
            const target = this.container[0];

            const { fetchEntities } = await (window as any).importShim('@solovis/pa-utils');
            await Solovis.UX.Utils.placeComponent(
                "AsyncSelect",
                target,
                {
                    cacheOptions: true,
                    defaultValue: (self.options as any).initialValue || undefined,
                    getOptionLabel: (option: Entity) => option.label,
                    getOptionValue: (option: Entity) => option.resourceId + '',
                    loadOn: "input",
                    loadOptions: (search: string) => new Promise(async (resolve, reject) => {
                        try {
                            const options = await fetchEntities({ filterText: search, maxItems: 10, excludeDemotedItems: true });
                            if (options.hasMoreData) {
                                options.data.push({
                                    label: "More Results",
                                    entityId: -1,
                                    resourceId: -1,
                                    originalQuery: { filterText: search, excludeDemotedItems: true },
                                })
                            }
                            resolve(options.data);
                        } catch (e) {
                            reject(e);
                        }
                    }),
                    onChange: (selectedItem) => {
                        //if nothing selected don't notify
                        if (!selectedItem) {
                            return;
                        }
                        if (selectedItem.label === "More Results") {
                            fetchEntities({ filterText: selectedItem.originalQuery.filterText, excludeDemotedItems: false, includeAll: true }).then(entities => {
                                var data = entities.data;

                                Solovis.UI.Dialogs.StringFilterListDialog.showDialog({
                                    title: "Select Entity",
                                    selectCallback: function (selectedItem) {
                                        self._selectRef.setValue(selectedItem);
                                    },
                                    stringFilterListControlOptions: {
                                        listItems: data,
                                        itemDivGenerator: function (itemHolder, filterOptions) {
                                            var itemDiv = $("<div>").text(itemHolder.item.label);
                                            itemDiv.prepend(Solovis.UI.Icons.createEntityIcon({ "padding-right": "10px" }));
                                            return itemDiv;
                                        }
                                    }
                                });
                            });
                            setTimeout(() => { //wait then clear the more results
                                self._selectRef.clearValue();
                            }, (0));
                            return;
                        }
                        self.currentEntity = selectedItem;
                        self.notifyParameterValueChanged();
                    },
                    ref: (ref) => {
                        self._selectRef = ref;
                    }
                }
            );
        }

        private doRenderClassic() {
            var self = this;

            this.selectedEntityLabel = $("<a>").appendTo(this.container);
            Solovis.UI.PopupLinkPanel.onElementClick(this.selectedEntityLabel, function (e) {
                if (self.currentEntity && self.currentEntity.entityId) {
                    // NOTE: Do not use autoClickSingleItem here. It's not a good experience if someone is trying
                    //   to click the edit link and ends up jumping to another page instead.
                    Solovis.UI.PopupLinkPanel.showLinks({
                        offset: { left: e.pageX, top: e.pageY },
                        links: self._portalServices.reportLinker().getEntityLinks(self.currentEntity.entityId)
                    });
                }
            });

            this.selectEntityLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

            Solovis.UI.DomHelper.focusableClick(this.selectEntityLink, function () {
                self._toggleSelectorDialog(function (entity) {
                    self._setCurrentEntityData(entity);
                    self.notifyParameterValueChanged();
                });
            });

            // Set initial parameter value text.
            if (this.currentEntity) {
                this._setCurrentEntityData(this.currentEntity);
            }

            // Setup drop handler for Solovis reference.
            Solovis.Site.DragDropManager.setupSolovisRefDrop(this.container, function (solovisRef) {
                if (!solovisRef.type || solovisRef.type == "entity" || solovisRef.type == "entityOrInvestment") {
                    self.setParameterValue(solovisRef.value);
                }
            });
        };

        public _setCurrentEntityData(entityData) {
            this.currentEntity = entityData;
            if (this.currentEntity) {
                this.selectedEntityLabel.text(this.currentEntity.label + " ");
            }
            else {
                this.selectedEntityLabel.text("");
            }
        }


        public setParameterValue(newValue, more?) {
            Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
                this, EntityParameterControl, this._setCurrentEntityData, newValue, more);
        }

        public getParameterValue() {
            return Solovis.deepCopy(this.currentEntity);
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }

        public focus() {
            $(this.selectEntityLink).focus();
        }

        public _toggleSelectorDialog(selectionCallback) {
            var self = this;

            if (this._selectionDialog) {
                // We already have the selection dialog open, so close it.
                this._selectionDialog.close();
                this._selectionDialog = null;
                return;
            }

            var entitySelectorControlHostDiv = $("<div>");
            var entitySelectorControlHost = new Solovis.UI.ControlHost({ container: entitySelectorControlHostDiv });
            var entitySelectorControl = new Solovis.InvDataSelectors.EntitySelectorControl({
                controlHost: entitySelectorControlHost,
                portalServices: this._portalServices,
                selectionCallback: function (entity) {
                    selectionCallback(entity);
                    self._selectionDialog.close();
                },
                cancelCallback: function () {
                    self._selectionDialog.close();
                }
            });
            entitySelectorControlHost.setCurrentControl(entitySelectorControl);

            // Determine dialog position.        
            var linkOffset = $(this.selectedEntityLabel).offset();
            var linkHeight = $(this.selectEntityLink).outerHeight();
            var dialogPosition = {
                left: linkOffset.left,
                top: linkOffset.top + linkHeight + 5
            };

            var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

            this._selectionDialog = new Solovis.UI.Dialog({
                container: entitySelectorControlHostDiv,
                ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

                title: false,
                autoOpen: true,
                destroyOnClose: true,
                actions: ["Close"],
                noAnimation: true,
                position: adjustedPosition,

                buttons: [
                    {
                        label: "Clear",
                        click: function () {
                            selectionCallback(null);
                            self._selectionDialog.close();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._selectionDialog.close();
                        }
                    }
                ],

                activate: function () {
                    entitySelectorControl.focus();
                },

                deactivate: function () {
                    self._selectionDialog = null;
                }
            });
        };
    }
}